var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dis == 3)?_c('div',{staticClass:"mcenter mt45vh"},[_c('div',{staticClass:"border p10"},[_c('open-app',{attrs:{"ids":_vm.ids}})],1)]):_c('div',[_c('info-display',{attrs:{"datalist":_vm.datalist,"datainfo":_vm.datainfo,"ids":_vm.ids}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }